import BaseModel from '../BaseModel';

export default class Address extends BaseModel {
  static entity = 'addresses';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      companyId: this.attr(null),
      vacancyId: this.attr(null),
      placeId: this.string(null).nullable(),
      city: this.string(null).nullable(),
      address: this.string(null).nullable(),
      coordinates: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      store(payload) {
        return this.post('addresses', payload);
      },
      update(id, payload) {
        return this.put(`addresses/${id}`, payload);
      },
      destroy(id) {
        return this.delete(`addresses/${id}`, { delete: id });
      },
      geocode(address) {
        return this.post('addresses/geocode', { address }, { save: false });
      },
      fetchCompanyAddresses() {
        return this.get('vacancy_lists/addresses');
      },
    },
  }
}
